import React from 'react'
import {Flex} from '@instructure/ui';
import {Alerts} from './Alerts.jsx';

/**
 * Alerts that don't affect the layout of elements below.
 */
export function FloatingAlerts({alerts, onDismiss}) {
    return (
        <Flex>
            <Flex.Item shouldGrow>
                {/* Use relative/absolute positioning so alerts are taken out of normal document flow and don't cause layout shifts below. */}
                <div style={{position: 'relative', maxWidth: '80em'}}>
                    <div
                        style={{
                            position: 'absolute',
                            top: '1.5em',
                            left: 0,
                            right: 0,
                            zIndex: 10
                        }}
                    >
                        <Alerts alerts={alerts} onDismiss={onDismiss}/>
                    </div>
                </div>
            </Flex.Item>
        </Flex>
    )
}